<template>
  <List
    class="px-3 overflow-x-auto"
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <!-- 先处理这个 -->
    <!-- //列表的是这个结构 -->
    <div v-if="$store.state.user.distributionFlag">
      <div
        v-for="(item, index) in goodsList"
        :key="index"
        class="flex flex-row mb-3 items-center"
      >
        <div
          class="img flex-shrink-0 flex-grow-0 rounded-md overflow-hidden"
          style="height: 116px; width: 116px"
          @click="goGoodsDetail(item.partGoodsId, item.partId)"
        >
          <img class="w-full h-full" :src="item.goodsImage" alt="" />
          <div class="buy-quantity" v-if="item.buyQuantity">
            {{
              item.buyQuantity > 100
                ? item.buyQuantity + '+'
                : item.buyQuantity
            }}人付款
          </div>
        </div>

        <div
          class="flex-grow flex flex-col ml-2 text-left justify-between py-1"
          style="height: 116px"
        >
          <div
            class="text-sm flex-shrink-0 flex-grow-0"
            style="
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            "
            @click="goGoodsDetail(item.partGoodsId, item.partId)"
          >
            <div
              v-show="item.state === 'IN_PROGRESS'"
              style="
                width: 36px;
                height: 20px;
                line-height: 20px;
                background: linear-gradient(135deg, #acf700 0%, #6edf0f 100%);
                border-radius: 5px;
              "
              class="text-xs inline-block text-center mr-1"
            >
              上新
            </div>
            <span>{{ item.goodsName }}</span>
          </div>
          <div
            :class="item.state === 'WARMING_UP' ? 'opacity-100' : 'opacity-0'"
          >
            <div
              style="color: #44d7b6; background-color: #d7fbf3"
              class="text-xxs inline-block float-left rounded-full px-3"
            >
              {{ dayjs(item.start).format('MM[月]DD[日]HH:mm') }}
              开售
            </div>
          </div>
          <div
            class="mt-1"
            @click="goGoodsDetail(item.partGoodsId, item.partId)"
          >
            <span class="font-semibold">¥</span
            ><span class="font-semibold text-2xl mr-1">{{ item.actPrice }}</span
            ><span class="text-red font-semibold text-sm"
              >省赚
              <span class="text-base">
                {{ item.saveProfit }}
                <span
                  class="text-sm"
                  v-if="item.activityReward === 'COMMISSION'"
                  >*2</span
                >
              </span></span
            >
          </div>
          <div
            class="flex items-center"
            style="width:100%;justify-content: flex-end"
          >
            <div
              class="flex items-center flex-shrink-0"
              @click="toActivityPlace(item.actId)"
              v-show="false"
            >
              <div
                class="font-xxxs"
                style="
                  width: 5rem;
                  display: inline-block;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ item.actName }}
              </div>
              <img class="ml-1" src="@/assets/小箭头.svg" alt="" />
            </div>
            <div class="flex flex-row items-center flex-shrink-0">
              <div
                class="flex items-center mr-1"
                @click="
                  $router.push({
                    name: 'BrandPlaceGoodsDetail',
                    params: {
                      id: item.partGoodsId,
                      oneTabBrandEveryPartId: item.partId,
                      showCart: true,
                    },
                  })
                "
              >
                <img
                  :src="
                    item.status === 'green'
                      ? require('@/assets/brandplace/greencart.svg')
                      : require('@/assets/brandplace/redcart.svg')
                  "
                  alt=""
                />
              </div>
              <div
                class="
                  inline-block
                  text-white
                  rounded-full
                  py-1
                  px-2
                  text-xs text-center
                "
                style="width: 5rem; max-height: 29px"
                :style="
                  item.status === 'green'
                    ? 'background-color:#44D7B6'
                    : 'background-color:#E82035'
                "
                @click="shareClick(item)"
              >
                分享赚&nbsp;<img
                  class="inline"
                  style="height: 1rem"
                  src="@/assets/brandplace/forward.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- //卡片的是这个结构 -->
    <div v-else class="flex flex-wrap">
      <div
        v-for="(item, index) in goodsList"
        :key="index"
        class="px-1 rounded-lg overflow-hidden box-border w-1/2 mb-2"
      >
        <div
          class="lightshadow bg-white"
          @click="
            $router.push({
              name: 'BrandPlaceGoodsDetail',
              params: {
                id: item.partGoodsId,
                oneTabBrandEveryPartId: item.partId,
              },
            })
          "
        >
          <VImage :src="item.goodsImage" class="w-full h-full" />
          <div class="flex mx-3">
            <div class="flex-grow text-left">
              <div
                style="
                  display: inline-block;
                  text-overflow: ellipsis;
                  overflow-x: hidden;
                  overflow-y: auto;
                  height: 2rem;
                "
                class="text-xs w-full"
              >
                {{ item.goodsName }}
              </div>
            </div>
          </div>
          <div class="flex justify-between">
            <div class="text-red ml-3">
              <span class="text-xs">¥</span
              ><span class="font-semibold mr-1">{{
                Math.round(item.actPrice * 100 + item.distMarkup * 100) / 100
              }}</span>

              <!-- 划线价 -->
              <span
                v-show="item.linePrice"
                class="text-xxs text-gray line-through"
              >
                ¥{{ item.linePrice }}
              </span>
            </div>

            <!-- 购物车 -->
            <div
              class="mr-2 mb-1"
              @click.stop="
                $router.push({
                  name: 'BrandPlaceGoodsDetail',
                  params: {
                    id: item.partGoodsId,
                    oneTabBrandEveryPartId: item.partId,
                    showCart: true,
                  },
                })
              "
            >
              <img src="@/assets/activityplace/redcart.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </List>
</template>

<script>
import { Icon, List, Image as VImage } from 'vant'
import { getPartGoods, getOneTabBrandGoods } from '../webApi'
import { priceMarkup, forwardDetail } from '@/api/forward.js'
export default {
  components: {
    // Icon,
    List,
    VImage,
  },
  props: {
    oneTabBrand: {
      type: String,
      default: null,
    },
    activeTab: {
      type: [String, Number],
      default: null,
    },
    sortColumn: { type: String, default: null }, //一个tab 品牌 排序筛选条件
  },
  created() {

    if (this.oneTabBrand) {
      // this.getOneTabBrandGoods()
    } else {
      this.getGoods()
    }
  },
  data() {
    return {
      page: 0,
      size: 10,
      loading: false,
      finished: false,
      goodsList: [],
      forwarding: null,

      browserType: localStorage.getItem('browserType'),
    }
  },

  watch: {
    activeTab: {
      immediate: true,
      handler(val) {

        console.log(1222, 'watch')
        this.page = 0
        this.goodsList = []
        this.loading = true
        this.finished = false
        if (this.loading && this.oneTabBrand) {

          this.getOneTabBrandGoods()
        }
      },
    },

    sortColumn: {
      // immediate: true,
      handler(val) {

        console.log(3333, 'sortColumn')
        this.page = 0
        this.goodsList = []
        this.loading = true
        this.finished = false
        if (this.loading && this.oneTabBrand) {

          this.getOneTabBrandGoods()
        }
      },
    },
  },
  methods: {
    onLoad() {
      if (this.oneTabBrand) {
        this.getOneTabBrandGoods()
      } else {
        this.getGoods()
      }
    },

    getGoods(
      params = {
        page: this.page,
        size: this.size,
        partId: this.$route.params.partId,
        actId: this.$route.query.actId,
        signBrandCateId: this.$route.query.signBrandCateId || null,
      }
    ) {
      getPartGoods(params).then((res) => {
        this.goodsList = this.goodsList.concat(res.data.content)
        this.page++
        this.loading = false
        if (this.goodsList.length >= res.data.totalElements) {
          this.finished = true
        }
      })
    },

    //首页列表或者卡片 点击每一个需要传的
    goGoodsDetail(id, oneTabBrandEveryPartId) {

      this.$router.push({
        name: 'BrandPlaceGoodsDetail',
        params: { id, oneTabBrandEveryPartId },
      })
    },
    shareClick(data) {
      this.$store.dispatch('shareGoods/show', {
        params: {
          partId: data.partId,
          actId: data.actId,
          partGoodsId: data.partGoodsId,
          goodsId: data.goodsId,
          activityReward: data.activityReward,
        },

        shareOptions: {
          title: data.goodsName,
          desc: null,
          imgUrl: data.goodsImage,
        },
      })
    },
    toActivityPlace(aid) {
      this.$router.push({
        name: 'ActivityPlace',
        params: { aid },
      })
    },

    getOneTabBrandGoods(
      params = {
        page: this.page,
        size: this.size,
        //这个参数找张宇 问是哪个
        platformCateId: this.activeTab,
        sortColumn: this.sortColumn,
        sortRole: 'DESC',
      }
    ) {
      getOneTabBrandGoods(params).then((res) => {
        this.goodsList = this.goodsList.concat(res.data.content)
        this.page++
        this.loading = false
        if (this.goodsList.length >= res.data.totalElements) {
          this.finished = true
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.img {
  position: relative;
  .buy-quantity {
    position: absolute;
    bottom: 4px;
    right: 4px;
    padding: 4px 14px;
    line-height: 24px;
    font-weight: 400;
    font-size: 20px;
    border-radius: 32px;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.34);
  }
}
</style>
